<template>
  <div class="wrap">
    <div class="data-table-list-nolist">
      <img src="../assets/unpermitted.png" style="opacity:0.5" alt />
      <div style="font-size:20px; font-weight:700; margin-bottom:15px;">このページを表示する権限がありません</div>
      <div class="data-table-list-nolist-content">
        このページを表示するには、アカウントの管理者に連絡してこのページの表示権限の付与を依頼してください。
      </div>
      <el-button type="primary" @click="openUnpermittedDrawer()">管理者に連絡</el-button>
    </div>

    <unpermittedDrawer :type="'page'" :unpermitted_drawer.sync="unpermitted_drawer"/>
  </div>
</template>

<script>
import unpermittedDrawer from "./unpermitted_drawer.vue"

export default {
  name: "unpermitted",
  components: {
    unpermittedDrawer
  },
  data() {
    return {
      unpermitted_drawer: false
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {},
  methods: {
    openUnpermittedDrawer(){
      this.unpermitted_drawer = true
    }
  },
};
</script>
